module.exports = __webpack_public_path__ + "static/media/logo-black.f6d7d215.png";